import { memo } from 'react';

import MinimizeIconSVG from '@/assets/minimize-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IMinimizeIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={MinimizeIconSVG} {...props} />;

export const MinimizeIcon = memo(IMinimizeIcon) as typeof IMinimizeIcon;
